import { useTranslation } from 'react-i18next';

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@nucleus-commerce/ui/components/select';

import { useMediaFolders } from '../hooks/use-media-folders';
import { UNFILED } from '../schemas/media-list-search';

const ALL = '__all__';

export interface MediaFolderSelectProps {
  /** The folder to narrow to; undefined for every file. */
  value: string | undefined;
  onChange: (folderId: string | undefined) => void;
  className?: string;
  /** Offers "Not in a folder", whose value is `UNFILED`. */
  includeUnfiled?: boolean;
}

/** The folder filter the pickers share; it hides itself while the organization has no folders. */
export function MediaFolderSelect({
  value,
  onChange,
  className,
  includeUnfiled = false,
}: MediaFolderSelectProps) {
  const { t } = useTranslation('media');
  const folders = useMediaFolders();
  if (!folders.data || folders.data.length === 0) return null;
  return (
    <Select
      value={value ?? ALL}
      onValueChange={(next) => onChange(next === ALL ? undefined : next)}
    >
      <SelectTrigger className={className ?? 'w-[200px]'} aria-label={t('folders.filter')}>
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value={ALL}>{t('folders.filterAll')}</SelectItem>
        {includeUnfiled ? <SelectItem value={UNFILED}>{t('folders.unfiled')}</SelectItem> : null}
        {folders.data.map((folder) => (
          <SelectItem key={folder.id} value={folder.id}>
            {folder.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
